import { makeStyles } from '@material-ui/core';
import { headerHeight, footerHeight } from 'styles/abstract/variables';

export const makeMainContentStyles = makeStyles({
    main: {
        minHeight: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
        padding: '1rem 0',
    },
});
